import React from 'react';
import PageLoadingMask from 'components/masks/PageLoadingMask';
import ReviewEntryPointsModuleView from './ReviewEntryPointsModuleView';
import { useSelector } from 'react-redux';
import { REVIEW_ENTRY_POINTS } from 'types/morph.pagePosition.constants';
import { useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { useFlag } from 'hook/flag.hook';
import { factorMapping } from 'customHelpersPath/factorMapping.helper';

const ReviewEntryPointsModuleController = props => {
  const { userInfo } = props;
  const { selectedBureau, profileContainer, selectedFactor } = useSelector(
    state => ({
      selectedBureau: state?.score1b3bFactorDial?.bureau?.selectedBureau,
      profileContainer: state?.profileContainer?.profileContainer,
      selectedFactor: state?.score1b3bFactorDial?.factor?.selectedFactor,
    }),
  );
  const universalReview = useFlag('universal_review');
  const loading = props?.globalLoadingFlag;
  const trackingAtr = getViewModuleTrackingAttributes({
    pagePosition:
      REVIEW_ENTRY_POINTS + `${' - '}` + factorMapping?.get(selectedFactor),
    modulePosition: 1,
  });
  const seenModuleTracking = useSeenModulePixel(trackingAtr);

  if (loading) {
    return <PageLoadingMask description={'Loading...'} />;
  } else if (universalReview?.isEnabled) {
    return (
      <ReviewEntryPointsModuleView
        userInfo={userInfo}
        selectedBureau={selectedBureau}
        profileContainer={profileContainer}
        seenModuleTracking={seenModuleTracking}
        selectedFactor={selectedFactor}
        {...props}
      />
    );
  } else {
    return <></>;
  }
};

export default ReviewEntryPointsModuleController;
